import React from 'react';
import Svg from "../../../component/Svg";
import { toast } from 'react-toastify'; 

const ExportExcel = ({ selectedRows }) => {
  const handleExport = async () => {
    if (selectedRows.length === 0) {
      toast.error('Please select rows to export.');
      return; // Stop further execution
    }
    try {
      const xlsx = await import('xlsx');

      // Helper function to format column headers
      const formatHeader = (header) => {
        // Replace underscores with spaces and capitalize each word
        return header
          .replace(/_/g, ' ')
          .replace(/\b\w/g, (char) => char.toUpperCase());
      };

      if (selectedRows.length === 0) {
        return;
      }
      
      const headersToExclude = ['Id', 'Added By'];
      const headerKeys = Object.keys(selectedRows[0]).filter(
        (key) => !headersToExclude.includes(formatHeader(key))
      );
      
      const formattedHeaders = headerKeys.map(formatHeader);

      const data = selectedRows.map((row) =>
        headerKeys.map((key) => {
          const formattedKey = formatHeader(key);
          const value = row[key];

          if (
            ['Add Date Time', 'Created At', 'Updated At', 'Published'].includes(formattedKey) &&
            value
          ) {
            const datePart = value.split('/')[0];
            const date = new Date(datePart);
            if (!isNaN(date)) {
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = date.getFullYear();
              const hours = String(date.getHours()).padStart(2, '0');
              const minutes = String(date.getMinutes()).padStart(2, '0');
              return `${day}/${month}/${year} ${hours}:${minutes}`;
            }
          }
          return value;
        })
      );
      
      const worksheet = xlsx.utils.aoa_to_sheet([formattedHeaders, ...data]);

      // Set column widths
      worksheet['!cols'] = formattedHeaders.map((header) => ({
        wch: Math.max(header.length, 20), // column width
      }));

      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      saveAsExcelFile(excelBuffer, 'RoiCalculatorExport');
    } catch (error) {
      console.error('Error exporting Excel:', error);
    }
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then((module) => {
      const EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const EXCEL_EXTENSION = '.xlsx';
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });

      module.default.saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  };

  return (
    <button className="btn btn-bordered ms-md-2 mt-2 mt-md-0 d-inline-flex align-items-center with-icon gap-10" onClick={handleExport}>
      <Svg name="export" /> Export
    </button>
  );
};

export default ExportExcel;
